/**
 * The bridge exposed by the GETFOOD Pro desktop app (send / sendSync / on / once / removeListener).
 *
 * `window.electron.ipcRenderer` is the legacy Electron shell, kept only until every terminal has
 * migrated to the Tauri desktop app. Remove that fallback afterwards.
 */
const desktopApp = () => {
  return window?.desktopApp || window?.electron?.ipcRenderer || null
}

export default desktopApp
